class LilLuxeTikTok extends HTMLElement {
  connectedCallback() {
    this.uploadedVideo = this.querySelector('.ll-ugc__video');
    this.uploadedCover = this.querySelector('[data-ll-uploaded-cover]');
    if (this.uploadedVideo && this.uploadedVideo.dataset.llCropReady !== 'true') {
      this.uploadedVideo.dataset.llCropReady = 'true';
      this.uploadedVideo.addEventListener('play', this.handleUploadedVideoPlay, { once: true });
    }
    if (this.uploadedVideo && this.uploadedCover && this.uploadedCover.dataset.llCoverReady !== 'true') {
      this.uploadedCover.dataset.llCoverReady = 'true';
      this.uploadedCover.addEventListener('click', this.handleUploadedCoverPlay);
    }

    this.button = this.querySelector('[data-ll-tiktok-play]');
    if (!this.button) return;
    this.button.addEventListener('click', this.handlePlay, { once: true });
  }

  handleUploadedVideoPlay = () => {
    this.uploadedVideo.dataset.llPlaying = 'true';
    if (this.uploadedCover) this.uploadedCover.hidden = true;
  };

  handleUploadedCoverPlay = (event) => {
    event.preventDefault();
    if (!this.uploadedVideo) return;

    this.uploadedVideo.dataset.llPlaying = 'true';
    this.uploadedCover.hidden = true;
    const playRequest = this.uploadedVideo.play();
    if (playRequest) {
      playRequest.catch(() => {
        delete this.uploadedVideo.dataset.llPlaying;
        this.uploadedCover.hidden = false;
      });
    }
  };

  handlePlay = (event) => {
    event.preventDefault();
    this.loadPlayer();
  };

  loadPlayer = () => {
    const videoId = this.dataset.videoId;
    const videoUrl = this.dataset.videoUrl;
    if (!videoId || !/^\d+$/.test(videoId)) {
      if (videoUrl) window.open(videoUrl, '_blank', 'noopener,noreferrer');
      return;
    }

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.tiktok.com/player/v1/${videoId}?autoplay=1&controls=1&description=1&music_info=0&rel=0`;
    iframe.title = this.dataset.videoTitle || 'Lil Luxe video on TikTok';
    iframe.loading = 'lazy';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.className = 'll-ugc__iframe';

    const frame = this.querySelector('[data-ll-tiktok-frame]');
    if (!frame) return;
    frame.replaceChildren(iframe);
    this.dataset.loaded = 'true';
  };
}

if (!customElements.get('ll-tiktok')) {
  customElements.define('ll-tiktok', LilLuxeTikTok);
}
